// extracted by mini-css-extract-plugin
export var cardContainer = "_q5-0";
export var cardHeader = "_q5-2";
export var collapsedState = "_q5-3";
export var dragHandle = "_q5-5";
export var dragHandleIcon = "_q5-6";
export var dragging = "_q5-1";
export var titleArea = "_q5-4";